export const TEAM_ASSIGNMENTS_PANEL_USER_ID_SET = 'at/userManagement/editTeamAssignmentPanel/TEAM_ASSIGNMENTS_PANEL_USER_ID_SET'

export const COPY_CONTENT_OPEN = 'at/userManagement/editTeamAssignmentPanel/COPY_CONTENT_OPEN'
export const COPY_CONTENT_CLOSE = 'at/userManagement/editTeamAssignmentPanel/COPY_CONTENT_CLOSE'
export const COPY_USER_ID_SET = 'at/userManagement/editTeamAssignmentPanel/copy/COPY_USER_ID_SET'
export const COPY_LOADING_SET = 'at/userManagement/editTeamAssignmentPanel/copy/COPY_LOADING_SET'
export const USER_FROM_ASSIGNED_USERS_SET = 'at/userManagement/editTeamAssignmentPanel/copy/USER_FROM_ASSIGNED_USERS_SET'
export const COPY_USERS_FOR_SELECTOR_SET = 'at/userManagement/editTeamAssignmentPanel/copy/COPY_USERS_FOR_SELECTOR_SET'


// WEBPACK FOOTER //
// ./web/js/panels/user/editTeamAssignmentsPanel/actionTypes.js